"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewSkeleton = void 0;
var _searchPreviewProduct = require("@ori/search-preview-product");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.times"));
var _react = require("react");
var _components = require("../SearchPreview/components");
var _styles = require("../SearchPreview/styles");
var _styles2 = require("../styles");
var _constants = require("./constants");
var _styles3 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_SKELETON),
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Queries, {
          children: (0, _lodash.default)(_constants.SUGGESTIONS_COUNT, index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
            "data-testid": getTestId(_constants.SEARCH_PREVIEW_SKELETON_SUGGESTION),
            animation: animation,
            width: 100,
            height: _components.CHIP_HEIGHT
          }, `${_constants.SEARCH_PREVIEW_SKELETON_SUGGESTION}-${index}`))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.SectionLabelSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Queries, {
          children: (0, _lodash.default)(_constants.BRANDS_COUNT, index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
            "data-testid": getTestId(_constants.SEARCH_PREVIEW_SKELETON_BRANDS),
            animation: animation,
            width: 100,
            height: _components.CHIP_HEIGHT
          }, `${_constants.SEARCH_PREVIEW_SKELETON_BRANDS}-${index}`))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.SectionLabelSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Products, {
          children: (0, _lodash.default)(_constants.PRODUCTS_COUNT, index => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchPreviewProduct.SearchPreviewProductSkeleton, {
              animation: animation
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDivider, {})]
          }, `${_constants.SEARCH_PREVIEW_PRODUCT_SKELETON}-${index}`))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        withPaddingBottom: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.SectionLabelSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Queries, {
          children: (0, _lodash.default)(_constants.CATEGORIES_COUNT, index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
            "data-testid": getTestId(_constants.SEARCH_PREVIEW_SKELETON_CATEGORIES),
            animation: animation,
            width: 100,
            height: _components.CHIP_HEIGHT
          }, `${_constants.SEARCH_PREVIEW_SKELETON_CATEGORIES}-${index}`))
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.SeeAllSkeleton, {})]
  });
};
exports.SearchPreviewSkeleton = SearchPreviewSkeleton;
//# sourceMappingURL=SearchPreviewSkeleton.js.map